import React from 'react';
import ReactDOM from 'react-dom';

import './visualsort.css';
import {visualMergeSort} from '../sorters/visualMergeSort.js';
import {visualBubbleSort} from '../sorters/visualBubbleSort.js';
import {visualCountingSort} from '../sorters/visualCountingSort.js';
import {visualHeapSort} from '../sorters/visualHeapSort.js';
import {visualQuickSort} from '../sorters/visualQuickSort.js';
import {visualCocktailShakerSort} from '../sorters/visualCocktailShakerSort.js';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
// import Typography from '@material-ui/core/Typography';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import deepOrange from '@material-ui/core/colors/deepOrange';
import green from '@material-ui/core/colors/green';

const theme = createMuiTheme({
  palette: {
    primary: deepOrange,
    secondary: green,
  },
});

const BAR_COLOR = "#79B6F2";
const READ_COLOR = "#98C379";
const WRITE_COLOR = "#E06B75";
const DONE_COLOR = "#C578DD";
const INPOSITION_COLOR = "#C578DD";
const PIVOT_COLOR = "#F7DC6F";

const SPEED = [1000,100,10,1,0.1]; //animation speed in ms

const WIDTH = window.innerWidth;
const HEIGTH = window.innerHeight;

const DEFAULT_BAR_NUM = Math.floor(WIDTH/1536*350); //350 number of bars in full screen;
const MINVAL = 5;
const MAXVAL = Math.floor(HEIGTH/872*750); //750 pixel in height when fullscreen

const MARKS_SPEED = [{value:0,label:"slomo"},{value:1,label:"slow"},{value:2,label:"mid"},{value:3,label:"fast"},{value:4,label:"turbo"}];
function valueLabelFormatSpeed(v){
    return MARKS_SPEED[v].label;
}

const MARKS_BARS = [{value:1,label:"5%"},{value:2,label:"12%"},
  {value:3,label:"25%"},{value:4,label:"50%"},{value:5,label:"100%"},
  {value:6,label:"200%"},{value:7,label:"400%"}];
function valueLabelFormatBars(v){
    return MARKS_BARS.find(MARKS_BARS => MARKS_BARS.value == v).label;
}


export default class VisualSort extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      array: [],
      barNum: DEFAULT_BAR_NUM,
      speed: 3,
    };
  }

  componentDidMount(){
    const array = generateArray(this.state.barNum);
    this.setState({array});
  }

  reset(multiplier = 1){
    let bars = document.getElementsByClassName('bar');
    for (let bar of bars){
      bar.style.backgroundColor = BAR_COLOR;
    }
    let barNum = DEFAULT_BAR_NUM * multiplier;
    const array = generateArray(barNum);
    this.setState({array,barNum});
    this.render();
  }

  mergeSort(){
    const animations = visualMergeSort(this.state.array);

    for (let i = 0; i < animations.length; i++) {
      // console.log(animations[i]);
      const bars = document.getElementsByClassName('bar');
      const isColorChange = i % 3 !== 2;

      if (isColorChange) {
        const [barOneIdx, barTwoIdx] = animations[i];
        const barOneStyle = bars[barOneIdx].style;
        const barTwoStyle = bars[barTwoIdx].style;
        const color = i % 3 === 0 ? BAR_COLOR : READ_COLOR;
        setTimeout(() => {
          barOneStyle.backgroundColor = color;
          barTwoStyle.backgroundColor = color;
        }, i * SPEED);
      } else {
        setTimeout(() => {
          const [barOneIdx, newHeight] = animations[i];
          const barOneStyle = bars[barOneIdx].style;
          barOneStyle.height = `${newHeight}px`;
        }, i * SPEED);
      }
    }
  }

  quickSort(){
    const animations = visualQuickSort(this.state.array);

    let bars = document.getElementsByClassName('bar');
    let readsText = document.getElementsByClassName('complexity-text-reads');
    let writesText = document.getElementsByClassName('complexity-text-writes');

    let prevs = animations[0][1];

    let complexity = document.getElementsByClassName('complexity-text-complexity');
    complexity[0].innerText = "O(NlogN)";

    for (let i = 0; i < animations.length; i++) {

      console.log(animations[i]);

      let [type, indexes, values ,reads, writes] = animations[i];
      let styles = [];
      let color;

      for (let idx of indexes){
        styles.push(bars[idx].style);
      }

      if (type == 0){
        color = READ_COLOR;
      }
      else if (type == 1){
        color = WRITE_COLOR;
      }
      else if (type == 2){
        color = PIVOT_COLOR;
      }

      setTimeout(() => {
        // console.log(animations[i])
        for (let prev of prevs){
          bars[prev].style.backgroundColor = BAR_COLOR;
        }
        prevs = indexes;

        for (let [idx,style] of styles.entries()){
          style.backgroundColor = color;
          style.height = `${values[idx]}px`;
        }

        readsText[0].innerText = reads;
        writesText[0].innerText = writes;
      }, i * SPEED[this.state.speed])
    }

    setTimeout(() => {
      for (let prev of prevs){
        bars[prev].style.backgroundColor = BAR_COLOR;
      }
      this.doneAnimation(0);
    }, animations.length * SPEED[this.state.speed])
  }

  heapSort() {
    const animations = visualHeapSort(this.state.array);

    let bars = document.getElementsByClassName('bar');
    let readsText = document.getElementsByClassName('complexity-text-reads');
    let writesText = document.getElementsByClassName('complexity-text-writes');

    let prevs = animations[0][1];

    let complexity = document.getElementsByClassName('complexity-text-complexity');
    complexity[0].innerText = "O(NlogN)";

    for (let i = 0; i < animations.length; i++) {
      let [type, indexes, values ,reads, writes] = animations[i];
      let styles = [];
      let color;
      let update = false;

      for (let idx of indexes){
        styles.push(bars[idx].style);
      }

      if (type == 0){
        color = READ_COLOR;
        update = true;
      }
      else if (type == 1){
        color = WRITE_COLOR;
      }
      else if (type == 2){
        color = READ_COLOR;
      }

      setTimeout(() => {
        // console.log(animations[i])
        if (update){
          for (let prev of prevs){
            bars[prev].style.backgroundColor = BAR_COLOR;
          }
          prevs = indexes;
        }

        for (let [idx,style] of styles.entries()){
          style.backgroundColor = color;
          style.height = `${values[idx]}px`;
        }

        readsText[0].innerText = reads;
        writesText[0].innerText = writes;
      }, i * SPEED[this.state.speed])
    }

    setTimeout(() => {
      for (let prev of prevs){
        bars[prev].style.backgroundColor = BAR_COLOR;
      }
      this.doneAnimation(0);
    }, animations.length * SPEED[this.state.speed])
  }

  bubbleSortNEW(){
    visualBubbleSort()
  }

  bubbleSort(){
    const animations = visualBubbleSort(this.state.array);
    let bars = document.getElementsByClassName('bar');
    let prev = animations[0].slice(1,3);
    let readsText = document.getElementsByClassName('complexity-text-reads');
    let writesText = document.getElementsByClassName('complexity-text-writes');
    let complexity = document.getElementsByClassName('complexity-text-complexity');

    complexity[0].innerText = "O(N^2)";

    for (let i = 0; i < animations.length; i++) {
      let [type,a,b,ha,hb,reads,writes] = animations[i];
      let [prev_a, prev_b] = prev;
      const style1 = bars[a].style;
      const style2 = bars[b].style;
      let color;

      if (type == 0){ // 0=read
        color = READ_COLOR;
      }
      else if (type == 1){ // 1=write
        color = WRITE_COLOR;
      }
      setTimeout(() => {
        bars[prev_a].style.backgroundColor = BAR_COLOR;
        bars[prev_b].style.backgroundColor = BAR_COLOR;
        style1.backgroundColor = color;
        style2.backgroundColor = color;
        style1.height = `${ha}px`;
        style2.height = `${hb}px`;
        readsText[0].innerText = reads;
        writesText[0].innerText = writes;
      }, i* SPEED[this.state.speed]);

      prev = [a,b];
    }

    setTimeout(() => {
      bars[prev[0]].style.backgroundColor = BAR_COLOR;
      bars[prev[1]].style.backgroundColor = BAR_COLOR;
      this.doneAnimation(0);
    }, animations.length * SPEED[this.state.speed])
  }

  countingSort(){
    let animations = visualCountingSort(this.state.array,MINVAL,MAXVAL);

    let bars = document.getElementsByClassName('bar');
    let prev = animations[0][1];
    let readsText = document.getElementsByClassName('complexity-text-reads');
    let writesText = document.getElementsByClassName('complexity-text-writes');
    let complexity = document.getElementsByClassName('complexity-text-complexity');

    complexity[0].innerText = "O(N)";

    for (let i = 0; i < animations.length; i++) {
      let [type,a,h,reads,writes] = animations[i];
      let color;

      if (type == 0){ // 0=read
        color = READ_COLOR;
      }
      else if (type == 1){ // 1=write
        color = WRITE_COLOR;
      }
      setTimeout(() => {
        bars[prev].style.backgroundColor = BAR_COLOR;
        bars[a].style.backgroundColor = color;
        prev = a;
        bars[a].style.height = `${h}px`;
        readsText[0].innerText = reads;
        writesText[0].innerText = writes;
      }, i* SPEED[this.state.speed]);

    }

    setTimeout(() => {
      bars[prev].style.backgroundColor = BAR_COLOR;
      this.doneAnimation(0);
    }, animations.length * SPEED[this.state.speed])


  }

  cocktailShaker(){
    let animations = visualCocktailShakerSort(this.state.array);

    let bars = document.getElementsByClassName('bar');
    let readsText = document.getElementsByClassName('complexity-text-reads');
    let writesText = document.getElementsByClassName('complexity-text-writes');

    let prev = animations[0].slice(1,3);

    let complexity = document.getElementsByClassName('complexity-text-complexity');
    complexity[0].innerText = "O(N^2)";

    for (let i = 0; i < animations.length; i++) {
      let [type,a,b,ha,hb,reads,writes] = animations[i];
      let [prev_a, prev_b] = prev;
      const style1 = bars[a].style;
      const style2 = bars[b].style;
      let color;

      if (type == 0){ // 0=read
        color = READ_COLOR;
      }
      else if (type == 1){ // 1=write
        color = WRITE_COLOR;
      }
      setTimeout(() => {
        bars[prev_a].style.backgroundColor = BAR_COLOR;
        bars[prev_b].style.backgroundColor = BAR_COLOR;
        style1.backgroundColor = color;
        style2.backgroundColor = color;
        style1.height = `${ha}px`;
        style2.height = `${hb}px`;
        readsText[0].innerText = reads;
        writesText[0].innerText = writes;
      }, i* SPEED[this.state.speed]);

      prev = [a,b];
    }

    setTimeout(() => {
      bars[prev[0]].style.backgroundColor = BAR_COLOR;
      bars[prev[1]].style.backgroundColor = BAR_COLOR;
      this.doneAnimation(0);
    }, animations.length * SPEED[this.state.speed])
  }

  doneAnimation(t){
    let bars = document.getElementsByClassName('bar');
    for (let i = 0; i < this.state.array.length; i++){
      setTimeout(() => {
        bars[i].style.backgroundColor = DONE_COLOR;
      }, t+ i * SPEED[this.state.speed]/3);
    }
  }

  test() { //NOT TO USE WITH VISUAL SORTING, NEED ACTUAL ARRAY
    let arr = generateArray(1000);
    const correct = arr.slice().sort((a, b) => a - b);
    const myarr = visualMergeSort(arr.slice());
    console.log(areArraysEqual(correct, myarr));
  }

  render(){
    const {array} = this.state;
    const {barNum} = this.state;

    return (
      <MuiThemeProvider theme={theme}>
      <>
      <div className="bar-container">
      {array.map((value, index) => (
        <div
        className="bar"
        key={index}
        style = {{
          height: `${value}px`,
          width: `${2/ (barNum/DEFAULT_BAR_NUM)}px`,
          margin: `${1/ (barNum/DEFAULT_BAR_NUM)}px`,
          backgroundColor : BAR_COLOR,
        }}></div>
      ))}
      </div>

      <div className="buttons-bar">

        <div className="buttons-bar-text">
          Set array size: <br></br>
          Choose sorting algorithm: <br></br>
          Set speed level: <br></br>
        </div>

        <div className="buttons-bar-button">
          <div className="buttons-bar-slider">
            <Slider
              defaultValue={5}
              valueLabelDisplay="auto"
              valueLabelFormat={valueLabelFormatBars}
              step
              marks
              min={1}
              max={7}
              onChangeCommitted={(e,v) => this.reset(Math.pow(2,v-5))} />
          </div>

          <ButtonGroup color="primary" size="small" aria-label="small outlined button group">
            <Button onClick={() => this.mergeSort()}>Merge Sort</Button>
            <Button onClick={() => this.quickSort()}>Quick Sort</Button>
            <Button onClick={() => this.heapSort()}>Heap Sort</Button>
            <Button onClick={() => this.bubbleSort()}>Bubble Sort</Button>
            <Button onClick={() => this.countingSort()}>Counting Sort</Button>
            <Button onClick={() => this.cocktailShaker()}>Cocktail Shaker</Button>
          </ButtonGroup>

          <div className="buttons-bar-slider">
            <Slider
              defaultValue={3}
              valueLabelDisplay="auto"
              valueLabelFormat={valueLabelFormatSpeed}
              step
              marks
              min={0}
              max={4}
              onChangeCommitted={(e,v) => this.state.speed = v} />
          </div>
        </div>
      </div>

      <div className="complexity-bar">
        <div className="complexity-text">
          Complexity: <br></br>
          Number of reads: <br></br>
          Number of writes:
        </div>

        <div className="complexity-text-complexity">O(n*n)</div>
        <div className="complexity-text-reads">0</div>
        <div className="complexity-text-writes">0</div>
      </div>
      </>

    </MuiThemeProvider>
    )
  }
}

function randomInt(min, max) {
  // min is included, max is not included
  return Math.floor(Math.random() * (max - min) + min);
}

function generateArray(len = DEFAULT_BAR_NUM) {
    let array = [MAXVAL,MINVAL]; // min and max are always present

    for (let i=0; i<len-2; i++){
      array.push(randomInt(MINVAL+1, MAXVAL));
    }
    let randtemp = randomInt(2,len);
    [array[0] , array[randtemp]] = [array[randtemp], array[0]];
    randtemp = randomInt(1,len);
    [array[1] , array[randtemp]] = [array[randtemp], array[1]];
    return array;
  }

function areArraysEqual(a, b) {
    if (a.length !== b.length) return false;

    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
